// extracted by mini-css-extract-plugin
export var activeDot = "_8w-c";
export var buttonContainer = "_8w-9";
export var channelButton = "_8w-a";
export var clickable = "_8w-d";
export var content = "_8w-0";
export var contentFull = "_8w-2";
export var contentThird = "_8w-1";
export var contentWrapper = "_8w-7";
export var description = "_8w-5";
export var heightShort = "_8w-f";
export var image = "_8w-3";
export var imageContainer = "_8w-4";
export var selectButton = "_8w-e";
export var spinnerContainer = "_8w-b";
export var titleContent = "_8w-8";
export var titleWrapper = "_8w-6";